var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "SensitiveWords.Get",
    "options": {
        "objc_class_prefix": "SensitiveWordsGet",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "lastTime",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "extLastTime",
                    "id": 2
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "repeated",
                    "type": "SensitiveWords",
                    "name": "words",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "hasNext",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "updateTime",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "extUpdateTime",
                    "id": 4
                }
            ]
        },
        {
            "name": "SensitiveWords",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "content",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "status",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "lang",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "iden",
                    "id": 5
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "SensitiveType",
            "values": [
                {
                    "name": "DEFAULT",
                    "id": 0
                },
                {
                    "name": "USERNAME",
                    "id": 1
                },
                {
                    "name": "SIGNATURE",
                    "id": 2
                },
                {
                    "name": "CHAT",
                    "id": 4
                },
                {
                    "name": "LIVENAME",
                    "id": 8
                },
                {
                    "name": "LETTER",
                    "id": 16
                },
                {
                    "name": "AUTH",
                    "id": 32
                }
            ]
        }
    ]
}).build();

module.exports = _root;


// WEBPACK FOOTER //
// ./js/component/sensitive-words/index.pb.js